import { render } from "./SelectInginer.vue?vue&type=template&id=5b7c5552"
import script from "./SelectInginer.vue?vue&type=script&lang=js"
export * from "./SelectInginer.vue?vue&type=script&lang=js"

import exportComponent from "/home/ionut/PycharmProjects/frontend2/raportare/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__